import { Injectable } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';
import { TranslationService } from './translation.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PtyLdService {
  showingOverlay: boolean = false;
  private showLoadingCalls: number[] = [];
  private timeoutErrorMessage: string = 'This page was taking too long to load. Sending you back to the homepage.';

  constructor(
    private loading: LoadingController,
    private toast: ToastController,
    private router: Router
  ) { }

  setTimeoutErrorMessage(errorMessage) {
    this.timeoutErrorMessage = errorMessage;
  }

  getTimeoutErrorMessage() {
    return this.timeoutErrorMessage;
  }

  async showLoading(show: boolean, opts: any = {}) {

    /*
    if (show === false && this.showingOverlay === false) {
      return;
    }

    if (show === true && this.showingOverlay === true) {
      return;
    }

     */

    let loading: any = {present:async () => {}, dismiss: async () => {}};

    if (show) {

      const options: any = {
        spinner: opts.spinner,
        message: opts.message,
        duration: 0,
        translucent: true,
        cssClass: opts.fullScreen ? 'custom-app-loading' : 'custom-class'
      };

      if (opts.duration > 0) {
        options.duration = opts.duration;
      }

      try {
        loading = await this.loading.create(options);
      } catch (err) {}
      this.showingOverlay = true;

      const currentTime = (new Date()).getTime();
      this.showLoadingCalls.push(currentTime);

      const currentuser = JSON.parse(localStorage.getItem('pty_user_data'));
      let timeout = 4000;
      if (currentuser && currentuser.user && currentuser.user.server_side_search) {
        timeout = 30000;
      }
      if (options.duration > timeout) {
        timeout = options.duration;
      }

      // 30 second minute timeout and return to homepage... deals with long running API calls
      setTimeout(() => {
        /*
        if (this.showingOverlay && this.showLoadingCalls.includes(currentTime)) {
          this.showLoading(false, {message: this.timeoutErrorMessage});
          this.router.navigate(['/home']);
        }
         */
        try {
          this.showLoading(false);
        } catch (err) {}
      }, timeout);

      return await loading.present();
    } else {
      this.showLoadingCalls.pop();
      try {
        await this.loading.dismiss();
      } catch(err) {}
      this.showingOverlay = false;
    }

  }

  async showToast(message: string, duration: number = 0, buttonsOverride = []) {
    const options: any = {
      message: message,
      position: 'bottom'
    };

    if (duration > 0 && buttonsOverride.length === 0) {
      if (buttonsOverride.length > 0) {
        console.log('WARNING: buttonsOverride for toast message is being ignored because duration was provided.',
            {message, duration, buttonsOverride}
        );
      }
      options.duration = duration;

    } else if (buttonsOverride.length > 0) {
      options.buttons = buttonsOverride;

    } else {
      options.buttons = [
        {
          text: 'Ok',
          role: 'cancel',
          side: 'end',
        }
      ];
    }

    const toast = await this.toast.create(options);
    await toast.present();
    return toast;
  }

  async newMessageToast(message: any, duration: number = 0, buttonsOverride = []) {
    const toast = await this.showToast(message, duration, buttonsOverride);

    const handler = () => {
      try {
        toast.dismiss()
      } catch (err) {
        console.log('error dismissing toast: ', err);
      }
    };
    setTimeout(handler, duration || 3000);
  }
}


